import { chakra } from '@chakra-ui/react';
import type { LucideIcon } from 'lucide-react';

export interface AppNavItem<T extends string> {
  id: T;
  label: string;
  icon: LucideIcon;
}

interface AppNavButtonProps<T extends string> {
  item: AppNavItem<T>;
  active: boolean;
  onClick: () => void;
}

export function AppNavButton<T extends string>({ item, active, onClick }: AppNavButtonProps<T>) {
  return (
    <chakra.button
      type="button"
      aria-current={active ? 'page' : undefined}
      onClick={onClick}
      position="relative"
      display="inline-flex"
      flexShrink="0"
      alignItems="center"
      gap="2"
      borderRadius="oqPanel"
      px="5"
      py="3"
      fontSize="sm"
      fontWeight="medium"
      color={active ? 'text.primary' : 'text.muted'}
      bg={active ? 'brand.subtle' : undefined}
      borderWidth={active ? '1px' : undefined}
      borderColor={active ? 'signal.blue/20' : undefined}
      boxShadow={active ? 'inset 0 -1px 0 var(--oq-colors-signal-blue)' : undefined}
      transition="all 0.2s"
      {...(active ? {} : { _hover: { bg: 'white/0.04', color: 'text.primary' } })}
    >
      <item.icon size={16} />
      {item.label}
    </chakra.button>
  );
}